/// <amd-module name="Release/Landing/LeftPanel/PipelineSearch/PipelineSearch" />
import * as React from "react";

import { TimerManagement } from "VSS/Core/TimerManagement";
import { TextField } from "VSSUI/TextField";
import { css } from "VSSUI/Util";

import { IVssComponentContext } from "VSS/Platform/Layout";

import "VSS/LoaderPlugins/Css!Release/Landing/LeftPanel/PipelineSearch/PipelineSearch";

export interface IPipelineSearchProps {
    onSearchTextChanged: (text: string) => void;
    placeholderText: string;
    throttleWait?: number;
    className?: string;
    disabled?: boolean;
}

interface IPipelineSearchState {
    value: string;
}

export class PipelineSearch extends React.Component<IPipelineSearchProps, IPipelineSearchState> {
    private timerManagement: TimerManagement;

    constructor(props: IPipelineSearchProps, context: IVssComponentContext) {
        super(props, context);
        this.timerManagement = new TimerManagement();

        this._throttledFunction = this.timerManagement.throttle(
            (searchText: string) => this.props.onSearchTextChanged(searchText),
            this.props.throttleWait || 500,
            { leading: false });

        this.state = {
            value: ""
        };
    }

    public componentWillUnmount() {
        this.timerManagement.dispose();
    }

    public render(): React.ReactNode {
        return (
            <div className={css("pipeline-search", this.props.className)}>
                <TextField
                    placeholder={this.props.placeholderText}
                    onChange={(ev, val) => this._onChange(val)}
                    prefixIconProps={{iconName: "Search"}}
                    value={this.props.disabled ? "" : this.state.value}
                    disabled={this.props.disabled}
                    
                />
            </div >);

    }

    private _onChange = (value: string): void => {
        this.setState({ value: value });
        this._throttledFunction(value);
    }

    private _throttledFunction: (searchText: string) => void;
    private static readonly filterItemKey = "search-pipeline-filter-key";
}
